import React, { FC } from 'react'
import styles from './Flex.module.scss'
import cx from 'classnames'

export const JUSTIFY_OPTIONS = ['between', 'around', 'center', 'start', 'end'] as const
type Justify = typeof JUSTIFY_OPTIONS[number]

export const ALIGN_OPTIONS = ['start', 'end', 'center', 'baseline', 'stretch'] as const
type Align = typeof ALIGN_OPTIONS[number]

export const DIRECTION = ['vertical', 'horizontal'] as const
type Direction = typeof DIRECTION[number]

export const GAPS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const
type Gap = typeof GAPS[number]

type FlexProps = {
  inline?: boolean
  justify?: Justify
  align?: Align
  direction?: Direction
  gap?: Gap
  fullHeight?: boolean
  className?: string
  component?: keyof JSX.IntrinsicElements
}

export const Flex: FC<FlexProps> = ({
  inline = false,
  direction = 'horizontal',
  justify = '',
  align = '',
  gap = '',
  fullHeight = false,
  component: FlexComponent = 'div',
  ...props
}) => {
  const classes = cx({
    [styles.flex]: true,
    [styles.inline]: inline,
    [styles[`justify-${justify}`]]: justify,
    [styles[`align-${align}`]]: align,
    [styles[direction]]: direction,
    [styles[gap]]: gap,
    [styles.fullHeight]: fullHeight,
  })

  return <FlexComponent className={cx(classes, props.className)}>{props.children}</FlexComponent>
}

Flex.displayName = 'Flex'
